// extracted by mini-css-extract-plugin
export default {"container":"Table_container__SQG-V","table_head":"Table_table_head__6Zets","header":"Table_header__a2QgQ","sortable":"Table_sortable__muiAd"};